<template>
  <div>
    <v-card>
      <v-card-text>

        <template v-if="showFilterOptions">
          <v-chip-group column>

            <template v-if="hasValue(getCommsListConfig.queryParams.email)">
              <template v-for="email in getCommsListConfig.queryParams.email">
                <v-chip small close :key="email" @click:close="removeConfigFilter('email', email)">
                  <span><b>Email:</b> {{ email }}</span>
                </v-chip>
              </template>
            </template>

            <template v-if="hasValue(getCommsListConfig.queryParams.phone_number)">
              <template v-for="number in getCommsListConfig.queryParams.phone_number">
                <v-chip small close :key="number" @click:close="removeConfigFilter('phone_number', number)">
                  <span><b>Phone:</b> {{ number }}</span>
                </v-chip>
              </template>
            </template>

          </v-chip-group>
        </template>
       
        <v-data-table :headers="headers" :items="getCommsList" :loading="getFetchCommsListLoading" :server-items-length="getCommsListConfig.paginationCount" :page.sync="options.pagination.page" :options.sync="options.pagination" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}" @click:row="openCommDetailDialog">

          <template v-slot:item.timestamp="{item}">
            <span>{{ item.timestamp | formatDate }}</span>
          </template>

          <template v-slot:item.kind="{item}">
            <span class="primary--text">{{ item.kind | customPlaceholder}}</span>
          </template>

          <template v-slot:item.direction="{item}">
            <span>{{ item.direction | customPlaceholder}}</span>
          </template>

          <template v-slot:item.user="{item}">
            <span>{{ item.user | customPlaceholder}}</span>
          </template>

        </v-data-table>

        <CommDetailDialog :open="commDetailDialogOpen" @close="commDetailDialogOpen=false"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';
  import CommDetailDialog from '@/components/Comms/CommDetailDialog/CommDetailDialog';

  export default {
    components: { CommDetailDialog },

    data() {
      return {
        headers: [
          {text: 'Timestamp', sortable: false, value: 'timestamp'},
          {text: 'Kind', sortable: false, value: 'kind'},
          {text: 'System', sortable: false, value: 'system'},
          {text: 'Direction', sortable: false, value: 'direction'},
          {text: 'Recipient', sortable: false, value: 'recipient'},
          {text: 'Sender', sortable: false, value: 'sender'},
          {text: 'User', sortable: false, value: 'user'},
          {text: 'Name', sortable: false, value: 'name'}
        ],
        options: {
          pagination: {
            page: 1,
            itemsPerPage: 50,
            sortBy: [],
            sortDesc: [],
          },
          queryParams: {},
        },
        itemsPerPageOptions: [5,10,15,25,50],
        commDetailDialogOpen: false,
      }
    },

    computed: {
      ...mapGetters('comms', ['getCommsList', 'getFetchCommsListLoading', 'getCommsListConfig']),

      showFilterOptions() {
        return this.hasValue(this.getCommsListConfig.queryParams.email) || this.hasValue(this.getCommsListConfig.queryParams.phone_number);
      },

      getSort() {
        return this.options.pagination.sortBy[0] || "-timestamp";
      },

      hasValue() {
        return (val) => val && val.length;
      }
    },

    watch: {
      "options.pagination": {
        immediate: false,
        handler() {
          const query = {
            pagination: {
              page: this.options.pagination.page,
              page_size: this.options.pagination.itemsPerPage,
              ordering: this.getSort,
            },
            queryParams: { ...this.options.queryParams }
          };

          this.updateCommsListConfigPagination(query);

          if(this.options.queryParams) {
            delete this.options.queryParams;
          }
        },
        deep: true,
      }
    },

    async created() {
      const queryParams = JSON.parse(JSON.stringify(this.$route.query));
      const emails = JSON.parse(localStorage.getItem('comms_emails'));
      const phone_numbers = JSON.parse(localStorage.getItem('comms_numbers'));
      
      if(Object.keys(queryParams).length) {
        this.options.pagination.page = parseInt(queryParams.page);
        this.options.pagination.itemsPerPage = parseInt(queryParams.page_size);
        this.options.pagination.sortBy = queryParams.ordering ? [queryParams.ordering] : [];
        this.options.pagination.sortDesc = queryParams.order === 'asc' ? [false] : queryParams.order === 'desc' ? [true] : [true];
        this.options.queryParams = { ...queryParams };
      } else {
        this.options.page = 1;
        this.options.pagination.itemsPerPage = 50;
        this.options.pagination.sortBy = [this.getSort];
        this.options.pagination.sortDesc = [true];
      }

      if (emails) { this.options.queryParams.email = emails }
      if (phone_numbers) { this.options.queryParams.phone_number = phone_numbers }

      localStorage.removeItem('comms_emails');
      localStorage.removeItem('comms_numbers');
    },

    beforeDestroy() {
      this.RESET_COMMS_STORE();
    },

    methods: {
      ...mapMutations('comms', ['SET_COMM_DETAIL', 'RESET_COMMS_STORE']),
      ...mapActions('comms', ['updateCommsListConfigPagination']),

      openCommDetailDialog(item) {
        this.SET_COMM_DETAIL(item);
        this.commDetailDialogOpen = true;
      },

      removeConfigFilter(option, value) {
        const filtered = this.getCommsListConfig.queryParams[option].filter(configFilter => configFilter !== value);
        this.updateCommsListConfigPagination({ 
          queryParams: {
            [option]: filtered,
          } 
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>